import styled from 'styled-components';

export const ConstructionRegistrationResumeBlock = styled.div`
  display: flex;
  flex-direction: column;
  background-color: ${({ theme }) => theme.colors.white};
  padding: 1rem 1.5rem;
  margin-bottom: 0.5rem;

  & > header {
    display: flex;
    justify-content: space-between;
    gap: 1rem;
  }

  & > .subtitle {
    font-size: 1rem;
    color: ${({ theme }) => theme.colors.grayDark4};
  }
`;

export const ActionsFooter = styled.footer`
  display: flex;
  justify-content: flex-end;
  flex-wrap: wrap;
  gap: 1.5rem;
  padding: 2rem 0;

  & > button {
    width: 100%;

    @media (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
      max-width: 23rem;
    }
  }
`;
